//import React, {Component} from 'react';
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Typography from '@material-ui/core/Typography';
//import {Document, Page} from "react-pdf";
import {Img} from 'react-image';
import Grid from "@material-ui/core/Grid";
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import Image from 'material-ui-image';
import {bindActionCreators} from "redux";
import {
  loadTowJobsPictureIds,
  loadTowjobsData,
  loadTowjobsDataWithFilter, setTowColorFilter,
  setTowEndTimeFilter,
  setTowMakeFilter,
  setTowModelFilter,
  setTowPlateFilter,
  setTowStartTimeFilter,
  setTowStatusFilter,
  setTowVinFilter, setTowYearFilter
} from "../../redux/modules/towjob";
import {connect} from "react-redux";
import {DEFAULT_VESPAAN_SERVER as MainConstant, DEFAULT_VESPAAN_SERVER} from "../../utils/MainConstants";
import PrismaZoom from 'react-prismazoom';
import axios from "axios";

const styles = {
    card: {
        maxWidth: 900
    },
    media: {
        // ⚠️ object-fit is not supported by IE 11.
        objectFit: 'cover',
    },
};




//'url(' + require('../../images/IMG_1.JPG')
class ShowPicturesForDispatch extends React.Component {

            state={
              loadError: false,
              pictureArray:[],
              imgUrls:{},
            }
            constructor(props) {
                super(props);
                this.getPictureGridTile=this.getPictureGridTile.bind(this);
                this.getTextForPictureTiles=this.getTextForPictureTiles.bind(this);
              this.loadTowPictures=this.loadTowPictures.bind(this);
              

            }
  
  componentWillMount(){
    let {loadTowJobsPictureIds} = this.props;
    loadTowJobsPictureIds(DEFAULT_VESPAAN_SERVER.url, this.props.passedDispatchLog.id);
    
  }
  
  componentDidMount(){
    //let {loadTowJobsPictureIds} = this.props;
    //loadTowJobsPictureIds(DEFAULT_VESPAAN_SERVER.url, this.props.passedTowJob.id);
    this.loadTowPictures();
    
  }
  
  loadTowPictures = async () => {
    const { towjobsPictureIds, accessToken } = this.props;
    const baseUrl = DEFAULT_VESPAAN_SERVER.url;
    
    // cleanup old object URLs
    Object.values(this.state.imgUrls).forEach(URL.revokeObjectURL);
    
    const pairs = await Promise.all(
      towjobsPictureIds.map(async (tile) => {
        console.log("loadTowPictures pictureId is " + tile);
        try {
          const res = await axios.get(`${baseUrl}towpictures/${tile}`, {
            headers: {Authorization: `Bearer ${accessToken}`},
            responseType: 'blob',
          });
          
          const objectUrl = URL.createObjectURL(res.data);
          return [tile, objectUrl];
        }catch(err){
          console.error(`Failed to load image ${tile}`, err);
          return null; // 👈 mark as failed
        }
      })
    );
    
      //this.setState({imgUrls: Object.fromEntries(pairs)});
        this.setState({ imgUrls: Object.fromEntries(pairs.filter(Boolean)) });
    
  };
  
  componentDidUpdate(prevProps) {
    if (
      prevProps.towjobsPictureIds !== this.props.towjobsPictureIds ||
      prevProps.accessToken !== this.props.accessToken
    ) {
      this.loadTowPictures();
    }
  }
  
  componentWillReceiveProps(nextProps) {
   let {loadTowJobsPictureIds} = this.props;
    if (this.props.passedDispatchLog !== nextProps.passedDispatchLog) {
      loadTowJobsPictureIds(DEFAULT_VESPAAN_SERVER.url, nextProps.passedDispatchLog.id);
      //this.setState({pictureArray:nextProps.towjobsPictureIds} );
    }
    if (this.props.pictureArray !== nextProps.towjobsPictureIds) {
      //loadTowJobsPictureIds(DEFAULT_VESPAAN_SERVER.url, nextProps.passedTowJob.id);
      this.setState({pictureArray:nextProps.towjobsPictureIds} );
    }
   
  }
  
  getPictureGridTile() {
    const ids = this.props.towjobsPictureIds || {};
    
    return (
      <div>
        {ids.map((tile) => {
          const src = this.state.imgUrls[tile];
          
          return (
            <GridListTile key={tile} style={{ height: '100%', width:'100%',  }}>
              {/*<PrismaZoom  minZoom={0.1} maxZoom={10}  allowZoom allowWheel scrollVelocity={0.15}>*/}
              {src ? (
                <div
                  style={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: 'visible',
                    padding:15
                  }}
                >
                  
                  <img
                    src={src}
                    alt=""
                    style={{
                      maxWidth: '150%',
                      maxHeight: '100%',
                      width: 'auto',
                      height: 'auto',
                      display: 'block',
                      transformOrigin: 'center center',
                      padding:20
                    }}
                  />
                </div>
              ) : (
                <div style={{ padding: 12 }}>Loading…</div>
              )}
              {/*}</PrismaZoom>*/}
            </GridListTile>
          );
        })}
      </div>
    );
  }
  /*getPictureGridTile(){
             // let tempArray = this.state.pictureArray;
            let tempArray = this.props.towjobsPictureIds;
              return(tempArray.map((tile) => (
                  <GridListTile key={tile}  >
      <PrismaZoom  maxZoom={10} minZoom={1}>
                <Image   resizeMode="contain" src={DEFAULT_VESPAAN_SERVER.url+"towpictures/"+tile}   />
      </PrismaZoom>
                </GridListTile>
              ))
              )
    }*/
  
  getTextForPictureTiles(){
   let returnString = "There are no pictures associated with this dispatch. "
   let tempLenghtText = this.props.towjobsPictureIds.length;
    if(this.props.towjobsPictureIds.length >0){
      returnString ="There are " + tempLenghtText +" pictures";
    }
     return returnString;
  }
    
    render() {
            const {classes} = this.props;
            var tempList = this.getPictureGridTile();
            var tempTextForTiles = this.getTextForPictureTiles();
     
            return (
              <Grid container spacing={24}>
                  <Grid item xs={12} sm={12}>
                    
                    < Typography
                      variant = "h6"
                      component = "h5"  style={{display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',}}>
                  {this.props.passedDispatchLog.make} ,  {this.props.passedDispatchLog.model}   , {this.props.passedDispatchLog.type} <br/>
                  {this.props.passedDispatchLog.plate} / {this.props.passedDispatchLog.state} <br/>
                  {this.props.passedDispatchLog.vin}
              < /Typography>
                    
                    < Typography
                      variant = "h6"
                      component = "h5"
                      style={{ display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',}} >
                  {tempTextForTiles}
                  
                < /Typography>
                    <div
                      style={{
                        backgroundColor:'#093345'
                      }}
                    >
                    <GridList   cols={1}                  // one image per row
                                cellHeight={300}          // FIXED height for all tiles
                                style={{
                                  height: 450,            // enables vertical scrolling
                                  overflowY: 'auto',
                                  overflowX: 'hidden',
                                  paddingTop:10,
                                  paddingRight:30
                                }}   >
                        {tempList}
                  </GridList>
                    </div>
                  </Grid>
                </Grid>
    
        )
            ;
        }//end of render
}//End of class

ShowPicturesForDispatch.propTypes = {
    classes: PropTypes.object.isRequired,
};

//export default withStyles(styles)(ShowPictures);
const mapStateToProps = (state) => {
  return {
    towjobsPictureIds: state.towjob.towjobsPictureIds,
    accessToken: state.login.loginData.idToken,
    errorCMsg:state.towjob.errorCMsg,
  };
};


const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    loadTowJobsPictureIds:loadTowJobsPictureIds,
  }, dispatch);
};

//export default (withStyles(useStyles)(TowInfo));
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ShowPicturesForDispatch));



//I can put this inside the GridList above to generate teh grid list of pictures.
/*
{tileData.map((tile) => (
  <GridListTile key={tile.img} cols={tile.cols || 1}>
  <img src={tile.img} alt={tile.title} />
</GridListTile>
))}

*/
 /*
                < Card
            className = {classes.card} >
                < CardActionArea >
      
                < CardContent >
                < Typography
            variant = "h5"
            component = "h2" >
                Showing the Tow pictures here. {this.props.passedTowJob.vehiclemodel} and  {this.props.passedTowJob.vehiclevin}
                < /Typography>
                < Typography
            component = "p" >
              we will show the pictures related to the two here.
            < /Typography>
  
                <Img  style={{ height:200 , width:200, marginLeft:10, marginRight:10}}
                src={['http://localhost:2500/towpictures/someidhere']}
                
                />
               
                <Img  style={{ height:300 , width:400, marginLeft:10, marginRight:10 }}
                  src={[  'http://localhost:2500/towpictures2/someidhere']}
  
               />
               
               
              <List style={{ width: 800 }}>
            <ListItem
              innerDivStyle={{ paddingLeft: 80 }}
                >
                <Img  style={{ height:200 , width:200, marginLeft:10, marginRight:10}}
                  src={['http://localhost:2500/towpictures/someidhere']}
                  />
  
    
            </ListItem>
                </List>
            < /CardContent>
            < /CardActionArea>

            < /Card>
            */
